import { useTranslation } from "react-i18next";
import { Icon, Popup } from "semantic-ui-react";

import { PASSWORD_STRENGTH_THRESHOLD } from "modules/Login/components";
import "modules/UsersDashboard/components/PasswordCheckmarkIcon/PasswordCheckmarkIcon.scss";

type PasswordCheckmarkIconProps = {
  type: "new" | "confirm";
  passwordStrength: number;
  password?: string;
  confirmPassword?: string;
};

export const PasswordCheckmarkIcon = ({ type, confirmPassword, password, passwordStrength }: PasswordCheckmarkIconProps) => {
  const { t } = useTranslation();

  let trigger = null;
  let content = "";

  if (type === "new" && password && password.length > 0) {
    if (passwordStrength >= PASSWORD_STRENGTH_THRESHOLD) {
      trigger = <Icon name="check circle outline" className="checkIcon icon-style" color="green" />;
      content = t("v8_new_password_secure", "New password looks good");
    } else {
      trigger = <Icon className="crossIcon circle xmark outline icon-style" color="red" />;
      content = t("v8_new_password_not_secure", "New password is not secure enough");
    }
  }

  if (type === "confirm" && confirmPassword && confirmPassword.length > 0) {
    if (passwordStrength >= PASSWORD_STRENGTH_THRESHOLD && password === confirmPassword) {
      trigger = <Icon name="check circle outline" className="checkIcon icon-style" color="green" />;
      content = t("v8_new_confirm_password_secure", "New password confirmation looks good");
    } else {
      trigger = <Icon className="crossIcon circle xmark icon-style" color="red" />;
      content = t("v8_new_confirm_password_not_secure", "Confirmation is not the same as password or not secure enough");
    }
  }

  return (
    <div className="PasswordCheckmarkIcon">
      <Popup trigger={trigger} content={content} />
    </div>
  );
};
